import {locales} from './constants/locations'
// import {corporateURL} from './constants/index'
export const getCurrentLocal = ()=>{
	const currentPath = window.location.pathname; 

	const firstSegment = currentPath.split('/')[1];
	if(locales.includes(firstSegment)){
		return firstSegment
	}
	else{
		return 'en-us'
	}
}

export const checkReplaceUrl = (url) =>{

	const domain = window.origin

	if (url?.startsWith("https://preview.sandisk.com")) {
		url = url.replace("https://preview.sandisk.com", "https://www.sandisk.com");
		return url; 
	} else if ((domain ==='https://www-stage.sandisk.com/' || domain === 'https://www-stage.sandisk.com' || domain ===  "http://localhost:3001") && url?.startsWith("https://shop.sandisk.com")) {
		url = url.replace("https://shop.sandisk.com", "https://shop-uat.sandisk.com");
		return url; 
	} else{
		return url;
	}
	



	// const currentHost = window.location.origin; 
	// const defaultBaseUrl = "https://www.shop.sandisk.com/";
	// const cloudfrontBaseUrl = "https://dqf88de43dm8k.cloudfront.net/search";
	
	// let baseUrl;
	
	// if (currentHost === "http://localhost:3000" || currentHost === cloudfrontBaseUrl) {
	// 	baseUrl = defaultBaseUrl;
	// } else {
	// 	baseUrl = currentHost; 
	// }
	// 	if (/^https?:\/\//i.test(url)) {
	// 	return url; 
	// 	} 
	// 	else {
	// 		console.log('justdoit',  baseUrl);
	// 		console.log('justdoiturl',  url);
	// 		if(url){
	// 			return baseUrl + url.replace(/^\//, "");
	// 		}
			
	// 	}
	// const baseUrl = corporateURL; // Your predefined base URL

//   try {
//     const parsedUrl = new URL(url);

//     return url;
//   } catch (error) {
//     if (typeof url === "string") {
//       const cleanUrl = url.startsWith("/") ? url : `/${url}`;
//       return `${baseUrl}${cleanUrl}`;
//     }

//     console.log("Invalid URL provided:", error);
//   }

}

export const checkLearnMoreReplaceUrl = (url) =>{
	const domain = window.origin;
	let finaldomain = ''
	if (domain === 'https://www-stage.sandisk.com/' || domain === 'https://www-stage.sandisk.com' || domain === "http://localhost:3001"){
		finaldomain = "https://shop-uat.sandisk.com";
		if(url.startsWith('https://shop.sandisk.com')){
			url = url.replace('https://shop.sandisk.com','https://shop-uat.sandisk.com');
		}
	} else if (domain === 'https://www.sandisk.com/' || domain === 'https://www.sandisk.com'){
			finaldomain = "https://shop.sandisk.com"
	}

	if (url?.startsWith("https:") || url?.startsWith("http:")) {
		return url
	}
	else{
			return finaldomain+url
	}

}

export const checkDocReplaceUrl = (url) =>{
	const domain = window.origin
	const getlocales = window.location.href 
	const matchLocal = getlocales.match(/\/([a-z]{2}-[a-z]{2})\//i);
	const locale = matchLocal ? matchLocal[1]+'/' : '';
	let finaldomain = ''
	if (domain === 'https://www-stage.sandisk.com/' || domain === 'https://www-stage.sandisk.com'){
		finaldomain = "https://shop-uat.sandisk.com/"
	} else if (domain === 'https://www.sandisk.com/' || domain === 'https://www.sandisk.com'){
			finaldomain = "https://shop.sandisk.com/"
	}
	let docUrl = 'tools/documentRequestHandler?docPath='
	if (url?.startsWith("/content/dam/doc-library") || url?.startsWith("/content/dam/asset-library")) {
		return finaldomain+locale+docUrl+url
	}
	else{
		return url;
	}
}